import { useState, useCallback } from 'react';

/**
 * Minimal toast state: one transient message at a time.
 */
export default function useToast() {
  const [toast, setToast] = useState(null);

  const show = useCallback((message, tone = 'success') => {
    setToast({ message, tone });
    setTimeout(() => setToast(null), 3000);
  }, []);

  return { toast, show };
}
